import React from "react";
import {observer} from "mobx-react-lite";
import {useCsContext} from "../../state/CsInstance";

import styles from "./File.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRotate} from "@fortawesome/sharp-solid-svg-icons/faRotate";
import {faTrash} from "@fortawesome/sharp-solid-svg-icons/faTrash";
import {faPen} from "@fortawesome/sharp-solid-svg-icons/faPen";
import {faPenSlash} from "@fortawesome/sharp-solid-svg-icons/faPenSlash";

import {File as FileType} from "../../shared/Types";
import ChangeFilenameModalContent from "../Modals/ChangeFilenameModalContent";

type FileProps = {
	fileData: FileType;
	toggleResetModal: () => void;
};

const File: React.FC<FileProps> = (props) => {
	const {codeStore, globalModalStore} = useCsContext();
	const filename = props.fileData.name;

	// If this file is not meant to be visible, don't render it
	if (codeStore.visibleFileNames.indexOf(props.fileData.name) < 0) {
		return <></>;
	}

	const onClickFile = () => {
		codeStore.focusFile(props.fileData);
	};

	const showRenameModal = () => {
		if (!props.fileData.attributes?.isOriginal) {
			globalModalStore.showModal(
				<ChangeFilenameModalContent fileData={props.fileData} />
			);
		}
	};

	const classNames = [styles.fileNameWrapper];
	if (codeStore.focusedFile === filename) {
		classNames.push(styles.focusedFile);
	}

	const isOriginal = props.fileData?.attributes?.isOriginal;
	const revertButtonTitle = isOriginal ? "Reset File" : "Delete File";
	const revertButtonIcon = isOriginal ? faRotate : faTrash;
	const id = "file-" + props.fileData.name.replace(/[^\w0-9]/g, "-");

	return (
		<div
			id={id}
			className={classNames.join(" ")}
			onClick={onClickFile}
			onDoubleClick={showRenameModal}
		>
			<div className={styles.innerWrapper}>
				<span className={styles.fileName}>{filename}</span>
				<div className={styles.optionsContainer}>
					<button
						id={id + "RenameButton"}
						disabled={isOriginal}
						className={styles.option}
						title={isOriginal ? "Cannot Rename File" : "Rename File"}
						onClick={showRenameModal}
					>
						<FontAwesomeIcon
							icon={isOriginal ? faPenSlash : faPen}
							className={styles.optionIcon}
						/>
					</button>
					<button
						id={id + (isOriginal ? "Reset" : "Delete") + "Button"}
						className={styles.option}
						title={revertButtonTitle}
						onClick={props.toggleResetModal}
					>
						<FontAwesomeIcon
							icon={revertButtonIcon}
							className={styles.optionIcon}
						/>
					</button>
				</div>
			</div>
		</div>
	);
};

export default observer(File);
